import axios from 'axios';

// Enable cookies on ALL axios requests globally.
// This ensures httpOnly auth cookies are sent automatically.
axios.defaults.withCredentials = true;

// --- CSRF Protection ---
// Read the csrf_token cookie and attach it as X-CSRF-Token header on state-changing requests
function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

axios.interceptors.request.use((config) => {
  const method = (config.method || '').toUpperCase();
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    const token = getCsrfToken();
    if (token) {
      config.headers['X-CSRF-Token'] = token;
    }
  }
  return config;
});

// --- Frontend Error Tracking ---
// Report failed API calls to the monitoring backend
const BACKEND = process.env.REACT_APP_BACKEND_URL;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only report 5xx errors and network failures (skip 4xx like 401/404)
    const status = error?.response?.status;
    const shouldReport = !status || status >= 500;

    if (shouldReport && BACKEND) {
      const payload = {
        type: status ? 'api_error' : 'network_error',
        message: error?.message || 'Unknown error',
        url: error?.config?.url || '',
        status_code: status || null,
      };
      // Fire-and-forget — don't block the original error flow
      axios.post(`${BACKEND}/api/monitoring/frontend-error/`, payload).catch(() => {});
    }

    return Promise.reject(error);
  }
);

// --- Global JS Error Tracking ---
if (typeof window !== 'undefined' && BACKEND) {
  window.addEventListener('error', (event) => {
    const payload = {
      type: 'js_error',
      message: event.message || 'Unknown JS error',
      url: event.filename || window.location.href,
      stack: event.error?.stack || '',
    };
    // Use navigator.sendBeacon for reliability on page unload
    try {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(`${BACKEND}/api/monitoring/frontend-error/`, blob);
    } catch {
      axios.post(`${BACKEND}/api/monitoring/frontend-error/`, payload).catch(() => {});
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const payload = {
      type: 'unhandled_promise',
      message: event.reason?.message || String(event.reason) || 'Unhandled promise rejection',
      url: window.location.href,
      stack: event.reason?.stack || '',
    };
    try {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(`${BACKEND}/api/monitoring/frontend-error/`, blob);
    } catch {
      axios.post(`${BACKEND}/api/monitoring/frontend-error/`, payload).catch(() => {});
    }
  });
}

